"use strict";
!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="d3c83d10-004b-5015-93ee-43bff763fcda")}catch(e){}}();

Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateAggVenueExpensesForecast = exports.calculateAggVenueExpensesActual = exports.calculateAggVenueExpensesProjected = exports.calculateAggNetDeductionsForecast = exports.calculateAggNetDeductionsActual = exports.calculateAggNetDeductionsProjected = exports.calculateAggGrossDeductionsForecast = exports.calculateAggGrossDeductionsActual = exports.calculateAggGrossDeductionsProjected = exports.calculateAggNetAdjustmentsForecast = exports.calculateAggNetAdjustmentsActual = exports.calculateAggNetAdjustmentsProjected = exports.calculateAggGrossAdjustmentsForecast = exports.calculateAggGrossAdjustmentsActual = exports.calculateAggGrossAdjustmentsProjected = exports.calculateAggTicketFeesForecast = exports.calculateAggTicketFeesActual = exports.calculateAggTicketFeesProjected = exports.calculateAggBoxOfficeForecast = exports.calculateAggBoxOfficeActual = exports.calculateAggBoxOfficeProjected = exports.calculateTicketFeeForecast = exports.calculateTicketFeeActual = exports.calculateTicketFeeProjected = exports.calculateTicketFeePotential = exports.calculateRunFigures = exports.calculateRunExpensesForecast = exports.calculateRunExpensesProjected = exports.calculateRunExpensesActual = exports.calculateRunCommissionBuyouts = exports.calculateShowFigures = exports.calculateCommissions = exports.calculateShowScore = exports.calculateBoxOfficeScore = exports.calculateWalkoutScore = exports.calculateWalkout = exports.calculateNetAdjustments = exports.calculateNetDeductions = exports.calculateExpensesActual = exports.calculateExpensesProjected = exports.calculateShowBuyouts = exports.calculateTicketsSoldForecast = exports.calculateTicketsSoldActual = exports.calculateTicketsSoldProjected = exports.calculateGrossTicketActual = exports.calculateGrossTicketProjected = exports.calculateGrossTicketPotential = exports.calculateSellableCap = exports.calculateGrossDeductions = exports.calculateGrossAdjustments = void 0;
exports.__test = exports.calculateAggBuyouts = exports.calculateAggGuaranteeUsedActual = exports.calculateAggGuaranteeUsedProjected = exports.calculateAggWalkoutForecast = exports.calculateAggWalkoutActual = exports.calculateAggWalkoutProjected = exports.calculateAggBonusesForecast = exports.calculateAggBonusesActual = exports.calculateAggBonusesProjected = exports.calculateAggArtistShareOfRevenueForecast = exports.calculateAggArtistShareOfRevenueActual = exports.calculateAggArtistShareOfRevenueProjected = exports.calculateAggRevenueToSplitForecast = exports.calculateAggRevenueToSplitActual = exports.calculateAggRevenueToSplitProjected = void 0;
const show_1 = require("../types/show");
const numberFormatters_1 = require("../utils/numberFormatters");
const utils_1 = require("../utils/utils");
const calculateTicketPrice = (ticketType) => {
    return (0, numberFormatters_1.round)((ticketType.price ?? 0) -
        (ticketType.charityFee ?? 0) -
        (ticketType.facilityFee ?? 0));
};
const calculateGrossAdjustments = (show) => {
    return (0, numberFormatters_1.round)(show.ticketAdjustments
        ?.filter((a) => a.addToGross)
        ?.reduce((total, adjustment) => total + (adjustment.amount ?? 0), 0) ?? 0);
};
exports.calculateGrossAdjustments = calculateGrossAdjustments;
const calculateGrossDeductions = (show) => {
    return (0, numberFormatters_1.round)(show.deductions
        ?.filter((d) => d.addToGross)
        .reduce((total, deduction) => total + (deduction.amount ?? 0), 0) ?? 0);
};
exports.calculateGrossDeductions = calculateGrossDeductions;
const calculateSellableCap = (show) => {
    return (0, numberFormatters_1.round)(show.ticketTypes?.reduce((total, ticketType) => total + (ticketType.quantity ?? 0), 0));
};
exports.calculateSellableCap = calculateSellableCap;
const calculateGrossTicketPotential = (show) => {
    return (0, numberFormatters_1.round)(show.ticketTypes?.reduce((total, ticketType) => total + (ticketType.price ?? 0) * (ticketType.quantity ?? 0), 0));
};
exports.calculateGrossTicketPotential = calculateGrossTicketPotential;
const calculateGrossTicketProjected = (show) => {
    return (0, numberFormatters_1.round)(show.ticketTypes?.reduce((total, ticketType) => total + (ticketType.price ?? 0) * (ticketType.soldProjected ?? 0), 0));
};
exports.calculateGrossTicketProjected = calculateGrossTicketProjected;
const calculateGrossTicketActual = (show) => {
    return (0, numberFormatters_1.round)(show.ticketTypes?.reduce((total, ticketType) => total + (ticketType.price ?? 0) * (ticketType.sold ?? 0), 0));
};
exports.calculateGrossTicketActual = calculateGrossTicketActual;
const calculateTicketPotential = (show) => {
    return (0, numberFormatters_1.round)((0, exports.calculateGrossAdjustments)(show) -
        (0, exports.calculateGrossDeductions)(show) +
        show.ticketTypes?.reduce((total, ticketType) => total + calculateTicketPrice(ticketType) * (ticketType.quantity ?? 0), 0));
};
const calculateTicketProjected = (show) => {
    return (0, numberFormatters_1.round)((0, exports.calculateGrossAdjustments)(show) -
        (0, exports.calculateGrossDeductions)(show) +
        show.ticketTypes?.reduce((total, ticketType) => total +
            calculateTicketPrice(ticketType) * (ticketType.soldProjected ?? 0), 0));
};
const calculateTicketActual = (show) => {
    return (0, numberFormatters_1.round)((0, exports.calculateGrossAdjustments)(show) -
        (0, exports.calculateGrossDeductions)(show) +
        show.ticketTypes?.reduce((total, ticketType) => total + calculateTicketPrice(ticketType) * (ticketType.sold ?? 0), 0));
};
const calculateTicketForecasted = (show) => {
    if ((0, utils_1.isShowInActualStatus)(show)) {
        return calculateTicketProjected(show);
    }
    else {
        return calculateTicketActual(show);
    }
};
const calculateTicketsSoldProjected = (show) => {
    const total = show.ticketTypes?.reduce((total, ticketType) => total + (ticketType.soldProjected ?? 0), 0);
    return (0, numberFormatters_1.round)(total);
};
exports.calculateTicketsSoldProjected = calculateTicketsSoldProjected;
const calculateTicketsSoldActual = (show) => {
    return (0, numberFormatters_1.round)(show.ticketTypes?.reduce((total, ticketType) => total + (ticketType.sold ?? 0), 0));
};
exports.calculateTicketsSoldActual = calculateTicketsSoldActual;
const calculateTicketsSoldForecast = (show) => {
    if ((0, utils_1.isShowInActualStatus)(show)) {
        return (0, exports.calculateTicketsSoldActual)(show);
    }
    else {
        return (0, exports.calculateTicketsSoldProjected)(show);
    }
};
exports.calculateTicketsSoldForecast = calculateTicketsSoldForecast;
const calculateShowBuyouts = (show) => {
    return (0, numberFormatters_1.round)(show.productionBuyouts?.reduce((total, buyout) => total + (buyout.amount ?? 0), 0));
};
exports.calculateShowBuyouts = calculateShowBuyouts;
const calculateExpensesProjected = (show) => {
    return (0, numberFormatters_1.round)(show.expenses?.reduce((total, expense) => total + (expense.cost ?? 0) * (expense.quantity ?? 1), 0) ?? 0);
};
exports.calculateExpensesProjected = calculateExpensesProjected;
const calculateExpensesActual = (show) => {
    return (0, numberFormatters_1.round)(show.expenses?.reduce((total, expense) => total + (expense.actualCost ?? 0), 0) ?? 0);
};
exports.calculateExpensesActual = calculateExpensesActual;
const calculateNetDeductions = (show) => {
    return (0, numberFormatters_1.round)(show.deductions
        ?.filter((d) => !d.addToGross)
        .reduce((total, deduction) => total + (deduction.amount ?? 0), 0) ?? 0);
};
exports.calculateNetDeductions = calculateNetDeductions;
const calculateNetAdjustments = (show) => {
    return (0, numberFormatters_1.round)(show.ticketAdjustments
        ?.filter((a) => !a.addToGross)
        ?.reduce((total, adjustment) => total + (adjustment.amount ?? 0), 0) ?? 0);
};
exports.calculateNetAdjustments = calculateNetAdjustments;
const calculateBonusesAndProfitShare = (show, ticketsSold) => {
    let bonuses = 0;
    let profitSharePercent = show.profitSharePercent ?? 0;
    const sellableCap = (0, exports.calculateSellableCap)(show);
    if (show.dealType === show_1.ShowDealType.FLAT_FEE) {
        profitSharePercent = 0;
    }
    for (const ticketBonus of show.ticketBonuses) {
        if (ticketBonus.threshold > 0 && ticketBonus.threshold <= ticketsSold) {
            profitSharePercent = Math.max(profitSharePercent, ticketBonus.bonusPercent);
            bonuses += ticketBonus?.bonusAmount ?? 0;
        }
        else if (!!sellableCap &&
            ticketBonus.thresholdPercent > 0 &&
            ticketBonus.thresholdPercent <= (ticketsSold / sellableCap) * 100) {
            profitSharePercent = Math.max(profitSharePercent, ticketBonus.bonusPercent);
            bonuses += ticketBonus?.bonusAmount ?? 0;
        }
    }
    bonuses = (0, numberFormatters_1.round)(bonuses);
    profitSharePercent = (0, numberFormatters_1.round)(profitSharePercent);
    return { bonuses, profitSharePercent };
};
const calculateShowNet = (show, ticketRevenue, expenseTotal, profitSharePercent) => {
    const variableRev = (0, numberFormatters_1.round)(ticketRevenue * (profitSharePercent / 100));
    let bonuses = 0;
    let showNet = 0;
    let revenueToSplit = 0;
    let artistShareOfRevenue = 0;
    if (show.dealType === 'Flat Fee') {
        bonuses += ticketRevenue * (profitSharePercent / 100);
        showNet = show.guarantee || 0;
    }
    else if (show.dealType === 'Revenue Share') {
        if (ticketRevenue - expenseTotal < 0) {
            showNet = show.guarantee || 0;
        }
        else {
            showNet =
                (show.guarantee || 0) +
                    (ticketRevenue - expenseTotal) * (profitSharePercent / 100);
            revenueToSplit = ticketRevenue - expenseTotal;
        }
        artistShareOfRevenue = (revenueToSplit * profitSharePercent) / 100;
    }
    else {
        showNet = (ticketRevenue - expenseTotal) * (profitSharePercent / 100);
        if (showNet > (show?.guarantee || 0)) {
            revenueToSplit = ticketRevenue - expenseTotal;
            artistShareOfRevenue = (revenueToSplit * profitSharePercent) / 100;
        }
        else {
            showNet = show?.guarantee ?? 0;
            artistShareOfRevenue = 0;
        }
    }
    showNet = (0, numberFormatters_1.round)(showNet);
    revenueToSplit = (0, numberFormatters_1.round)(revenueToSplit);
    artistShareOfRevenue = (0, numberFormatters_1.round)(artistShareOfRevenue);
    bonuses = (0, numberFormatters_1.round)(bonuses);
    return {
        showNet,
        variableRev,
        revenueToSplit,
        artistShareOfRevenue,
        percentileBonuses: bonuses,
    };
};
const calculateWalkout = (show, showNet, showBuyouts, bonuses) => {
    const guarantee = show.guarantee ?? 0;
    const netDeductions = (0, exports.calculateNetDeductions)(show);
    const netAdjustments = (0, exports.calculateNetAdjustments)(show);
    if (show.dealType === 'Versus') {
        const guaranteeTotal = guarantee + showBuyouts + bonuses - netDeductions + netAdjustments;
        const variableTotal = showNet + showBuyouts + bonuses - netDeductions + netAdjustments;
        return (0, numberFormatters_1.round)(variableTotal > guaranteeTotal ? variableTotal : guaranteeTotal);
    }
    else if (show.dealType === 'Revenue Share') {
        return (0, numberFormatters_1.round)(showNet + showBuyouts + bonuses - netDeductions + netAdjustments);
    }
    else if (show.dealType === 'Flat Fee') {
        return (0, numberFormatters_1.round)(guarantee + showBuyouts + bonuses - netDeductions + netAdjustments);
    }
    return 0;
};
exports.calculateWalkout = calculateWalkout;
const calculateWalkoutScore = (walkout, walkoutPotential) => {
    if (walkoutPotential <= 0) {
        return 0;
    }
    return Math.round((walkout / walkoutPotential) * 100);
};
exports.calculateWalkoutScore = calculateWalkoutScore;
const calculateBoxOfficeScore = (walkout, ticketRevenue) => {
    if (ticketRevenue <= 0) {
        return 0;
    }
    return Math.round((walkout / ticketRevenue) * 100);
};
exports.calculateBoxOfficeScore = calculateBoxOfficeScore;
const calculateShowScore = (walkoutScore, boxOfficeScore) => {
    return Math.round((walkoutScore + boxOfficeScore) / 2);
};
exports.calculateShowScore = calculateShowScore;
const calculateCommissions = (show, revenue) => {
    const showCommissions = show.commissions?.map((commission) => {
        if (!!commission.flatFee) {
            return { ...commission, amount: commission.flatFee };
        }
        const commissionable = Math.max(0, revenue -
            (commission.commissionBuyout || 0) -
            (0, exports.calculateNetDeductions)(show) +
            (0, exports.calculateNetAdjustments)(show));
        return {
            ...commission,
            amount: commissionable * ((commission.percent ?? 0) / 100) +
                (commission.flatFee || 0),
        };
    });
    const commissionTotal = (0, numberFormatters_1.round)(showCommissions?.reduce((total, commission) => total + commission.amount, 0)) ?? 0;
    return { commissionTotal, commissions: showCommissions };
};
exports.calculateCommissions = calculateCommissions;
const calculateShowFigures = (show) => {
    const sellableCap = (0, exports.calculateSellableCap)(show);
    const ticketsSoldProjected = (0, exports.calculateTicketsSoldProjected)(show);
    const ticketsSoldActual = (0, exports.calculateTicketsSoldActual)(show);
    const ticketRevenuePotential = calculateTicketPotential(show);
    const ticketRevenueProjected = calculateTicketProjected(show);
    const ticketRevenueActual = calculateTicketActual(show);
    const showBuyouts = (0, exports.calculateShowBuyouts)(show);
    const venueExpensesProjected = (0, exports.calculateExpensesProjected)(show);
    const venueExpensesActual = (0, exports.calculateExpensesActual)(show);
    const { bonuses: ticketBonusesPotential, profitSharePercent: profitSharePotential, } = calculateBonusesAndProfitShare(show, sellableCap);
    const { showNet: showNetPotential, variableRev: variableRevPotential, revenueToSplit: revenueToSplitPotential, artistShareOfRevenue: artistShareOfRevenuePotential, percentileBonuses: dealBonusesPotential, } = calculateShowNet(show, ticketRevenuePotential, venueExpensesProjected, profitSharePotential);
    const walkoutPotential = (0, exports.calculateWalkout)(show, showNetPotential, showBuyouts, dealBonusesPotential + ticketBonusesPotential);
    const boxOfficeScorePotential = (0, exports.calculateBoxOfficeScore)(walkoutPotential, ticketRevenuePotential);
    const commissionsPotential = (0, exports.calculateCommissions)(show, showNetPotential + ticketBonusesPotential + dealBonusesPotential);
    const { bonuses: ticketBonusesProjected, profitSharePercent: profitShareProjected, } = calculateBonusesAndProfitShare(show, ticketsSoldProjected);
    const { showNet: showNetProjected, variableRev: variableRevProjected, revenueToSplit: revenueToSplitProjected, artistShareOfRevenue: artistShareOfRevenueProjected, percentileBonuses: dealBonusesProjected, } = calculateShowNet(show, ticketRevenueProjected, venueExpensesProjected, profitShareProjected);
    const walkoutProjected = (0, exports.calculateWalkout)(show, showNetProjected, showBuyouts, dealBonusesProjected + ticketBonusesProjected);
    const walkoutScoreProjected = (0, exports.calculateWalkoutScore)(walkoutProjected, walkoutPotential);
    const boxOfficeScoreProjected = (0, exports.calculateBoxOfficeScore)(walkoutProjected, ticketRevenueProjected);
    const showScoreProjected = (0, exports.calculateShowScore)(walkoutScoreProjected, boxOfficeScoreProjected);
    const commissionsProjected = (0, exports.calculateCommissions)(show, showNetProjected + ticketBonusesProjected + dealBonusesProjected);
    const { bonuses: ticketBonusesActual, profitSharePercent: profitShareActual, } = calculateBonusesAndProfitShare(show, ticketsSoldActual);
    const { showNet: showNetActual, variableRev: variableRevActual, revenueToSplit: revenueToSplitActual, artistShareOfRevenue: artistShareOfRevenueActual, percentileBonuses: dealBonusesActual, } = calculateShowNet(show, ticketRevenueActual, venueExpensesActual, profitShareActual);
    const walkoutActual = (0, exports.calculateWalkout)(show, showNetActual, showBuyouts, ticketBonusesActual + dealBonusesActual);
    const walkoutScoreActual = (0, exports.calculateWalkoutScore)(walkoutActual, walkoutPotential);
    const boxOfficeScoreActual = (0, exports.calculateBoxOfficeScore)(walkoutActual, ticketRevenueActual);
    const showScoreActual = (0, exports.calculateShowScore)(walkoutScoreActual, boxOfficeScoreActual);
    const commissionsActual = (0, exports.calculateCommissions)(show, showNetActual + ticketBonusesActual + dealBonusesActual);
    const walkoutMinimum = (0, exports.calculateWalkout)(show, show.guarantee ?? 0, showBuyouts, 0);
    return {
        show,
        sellableCap,
        venueExpensesProjected,
        walkoutMinimum,
        ticketRevenuePotential,
        boxOfficeScorePotential,
        variableRevPotential,
        revenueToSplitPotential,
        artistShareOfRevenuePotential,
        profitSharePercentPotential: profitSharePotential,
        showNetPotential,
        commissionsPotential,
        bonusesPotential: ticketBonusesPotential + dealBonusesPotential,
        walkoutPotential,
        ticketsSoldProjected,
        ticketRevenueProjected,
        boxOfficeScoreProjected,
        variableRevProjected,
        revenueToSplitProjected,
        artistShareOfRevenueProjected,
        profitSharePercentProjected: profitShareProjected,
        showNetProjected,
        commissionsProjected,
        bonusesProjected: ticketBonusesProjected + dealBonusesProjected,
        walkoutProjected,
        walkoutScoreProjected,
        showScoreProjected,
        ticketsSoldActual,
        ticketRevenueActual,
        boxOfficeScoreActual,
        venueExpenses: venueExpensesActual,
        variableRevActual,
        revenueToSplitActual,
        artistShareOfRevenueActual,
        profitSharePercentActual: profitShareActual,
        showNetActual,
        showBuyouts,
        commissionsActual,
        bonusesActual: ticketBonusesActual + dealBonusesActual,
        walkout: walkoutActual,
        walkoutScoreActual,
        showScoreActual,
    };
};
exports.calculateShowFigures = calculateShowFigures;
const calculateRunCommissionBuyouts = (run) => {
    return (0, numberFormatters_1.round)(run.commissionBuyouts?.reduce((total, buyout) => total + (buyout.amount ?? 0), 0) ?? 0);
};
exports.calculateRunCommissionBuyouts = calculateRunCommissionBuyouts;
const calculateRunExpensesActual = (run) => {
    return (0, numberFormatters_1.round)(run.expenses?.reduce((total, expense) => total + (expense.actualCost ?? 0), 0) ?? 0);
};
exports.calculateRunExpensesActual = calculateRunExpensesActual;
const calculateRunExpensesProjected = (run) => {
    return (0, numberFormatters_1.round)(run.expenses?.reduce((total, expense) => total + (expense.cost ?? 0) * (expense.quantity ?? 1), 0) ?? 0);
};
exports.calculateRunExpensesProjected = calculateRunExpensesProjected;
const calculateRunExpensesForecast = (run) => {
    return (0, numberFormatters_1.round)(run.expenses?.reduce((total, expense) => total +
        (expense.actualCost !== undefined &&
            expense.actualCost !== null &&
            expense.actualCost > -1
            ? expense.actualCost
            : expense.cost * expense.quantity), 0) ?? 0);
};
exports.calculateRunExpensesForecast = calculateRunExpensesForecast;
const calculateRunFigures = (run, shows) => {
    const runFigures = {
        walkoutPotential: 0,
        walkoutProjected: 0,
        walkoutForecast: 0,
        walkoutActual: 0,
        artistTakeHomePotential: 0,
        artistTakeHomeProjected: 0,
        artistTakeHomeForecast: 0,
        artistTakeHomeActual: 0,
        commissionsPotential: [],
        commissionsProjected: [],
        commissionsForecast: [],
        commissionsActual: [],
        artistExpensesProjected: 0,
        artistExpensesForecast: 0,
        artistExpensesActual: 0,
        showBuyouts: 0,
        marginProjected: 0,
        marginForecast: 0,
        marginActual: 0,
    };
    if (!run)
        return runFigures;
    const runShows = (0, show_1.showsForRun)(shows, run);
    const runExpensesActual = (0, exports.calculateRunExpensesActual)(run);
    const runExpensesProjected = (0, exports.calculateRunExpensesProjected)(run);
    const runExpensesForecast = (0, exports.calculateRunExpensesForecast)(run);
    for (const show of runShows) {
        const { showBuyouts, commissionsPotential, commissionsProjected, commissionsActual, walkoutPotential, walkoutProjected, walkout, } = (0, exports.calculateShowFigures)(show);
        runFigures.walkoutPotential += walkoutPotential;
        runFigures.artistTakeHomePotential += walkoutPotential;
        runFigures.showBuyouts += showBuyouts;
        commissionsPotential?.commissions?.forEach((commission, index) => {
            if (!runFigures.commissionsPotential[index]) {
                runFigures.commissionsPotential[index] = {
                    name: commission.name,
                    amount: 0,
                    percent: commission.percent,
                };
            }
            runFigures.commissionsPotential[index].amount += commission.amount;
            runFigures.artistTakeHomePotential -= commission.amount;
        });
        runFigures.walkoutProjected += walkoutProjected;
        runFigures.artistTakeHomeProjected += walkoutProjected;
        commissionsProjected?.commissions?.forEach((commission, index) => {
            if (!runFigures.commissionsProjected[index]) {
                runFigures.commissionsProjected[index] = {
                    name: commission.name,
                    amount: 0,
                    percent: commission.percent,
                };
            }
            runFigures.commissionsProjected[index].amount += commission.amount;
            runFigures.artistTakeHomeProjected -= commission.amount;
        });
        if (show.status === show_1.ShowStatus.SETTLED || show.status === show_1.ShowStatus.PAID) {
            runFigures.walkoutForecast += walkout;
            runFigures.artistTakeHomeForecast += walkout;
            commissionsActual?.commissions?.forEach((commission, index) => {
                if (!runFigures.commissionsForecast[index]) {
                    runFigures.commissionsForecast[index] = {
                        name: commission.name,
                        amount: 0,
                        percent: commission.percent,
                    };
                }
                runFigures.commissionsForecast[index].amount += commission.amount;
                runFigures.artistTakeHomeForecast -= commission.amount;
            });
        }
        else {
            runFigures.walkoutForecast += walkoutProjected;
            runFigures.artistTakeHomeForecast += walkoutProjected;
            commissionsProjected?.commissions?.forEach((commission, index) => {
                if (!runFigures.commissionsForecast[index]) {
                    runFigures.commissionsForecast[index] = {
                        name: commission.name,
                        amount: 0,
                        percent: commission.percent,
                    };
                }
                runFigures.commissionsForecast[index].amount += commission.amount;
                runFigures.artistTakeHomeForecast -= commission.amount;
            });
        }
        runFigures.walkoutActual += walkout;
        runFigures.artistTakeHomeActual += walkout;
        commissionsActual?.commissions?.forEach((commission, index) => {
            if (!runFigures.commissionsActual[index]) {
                runFigures.commissionsActual[index] = {
                    name: commission.name,
                    amount: 0,
                    percent: commission.percent,
                };
            }
            runFigures.commissionsActual[index].amount += commission.amount;
            runFigures.artistTakeHomeActual -= commission.amount;
        });
    }
    runFigures.marginProjected =
        runFigures.walkoutProjected - runExpensesProjected < 0
            ? 0
            : Math.round(((runFigures.artistTakeHomeProjected - runExpensesProjected) /
                runFigures.walkoutProjected) *
                100);
    runFigures.marginForecast =
        runFigures.walkoutForecast - runExpensesForecast < 0
            ? 0
            : Math.round(((runFigures.artistTakeHomeForecast - runExpensesForecast) /
                runFigures.walkoutForecast) *
                100);
    runFigures.marginActual =
        runFigures.walkoutActual - runExpensesActual < 0
            ? 0
            : Math.round(((runFigures.artistTakeHomeActual - runExpensesActual) /
                runFigures.walkoutActual) *
                100);
    runFigures.artistTakeHomeActual -= runExpensesActual;
    runFigures.artistTakeHomePotential -= runExpensesProjected;
    runFigures.artistTakeHomeProjected -= runExpensesProjected;
    runFigures.artistTakeHomeForecast -= runExpensesForecast;
    runFigures.artistExpensesActual = runExpensesActual;
    runFigures.artistExpensesProjected = runExpensesProjected;
    runFigures.artistExpensesForecast = runExpensesForecast;
    runFigures.artistTakeHomeActual = (0, numberFormatters_1.round)(runFigures.artistTakeHomeActual);
    runFigures.artistTakeHomePotential = (0, numberFormatters_1.round)(runFigures.artistTakeHomePotential);
    runFigures.artistTakeHomeProjected = (0, numberFormatters_1.round)(runFigures.artistTakeHomeProjected);
    runFigures.artistTakeHomeForecast = (0, numberFormatters_1.round)(runFigures.artistTakeHomeForecast);
    runFigures.walkoutActual = (0, numberFormatters_1.round)(runFigures.walkoutActual);
    runFigures.walkoutForecast = (0, numberFormatters_1.round)(runFigures.walkoutForecast);
    runFigures.walkoutPotential = (0, numberFormatters_1.round)(runFigures.walkoutPotential);
    runFigures.walkoutProjected = (0, numberFormatters_1.round)(runFigures.walkoutProjected);
    runFigures.artistExpensesActual = (0, numberFormatters_1.round)(runFigures.artistExpensesActual);
    runFigures.artistExpensesProjected = (0, numberFormatters_1.round)(runFigures.artistExpensesProjected);
    runFigures.artistExpensesForecast = (0, numberFormatters_1.round)(runFigures.artistExpensesForecast);
    return runFigures;
};
exports.calculateRunFigures = calculateRunFigures;
const calculateTicketFeePotential = (show) => {
    if (!show.ticketTypes || show.ticketTypes.length < 1)
        return 0;
    return show.ticketTypes.reduce((total, type) => {
        return (total +
            ((type.charityFee || 0) + (type.facilityFee || 0)) * (type.quantity ?? 0));
    }, 0);
};
exports.calculateTicketFeePotential = calculateTicketFeePotential;
const calculateTicketFeeProjected = (show) => {
    if (!show.ticketTypes || show.ticketTypes.length < 1)
        return 0;
    return show.ticketTypes.reduce((total, type) => {
        return (total +
            ((type.charityFee || 0) + (type.facilityFee || 0)) *
                (type.soldProjected ?? 0));
    }, 0);
};
exports.calculateTicketFeeProjected = calculateTicketFeeProjected;
const calculateTicketFeeActual = (show) => {
    if (!show.ticketTypes || show.ticketTypes.length < 1)
        return 0;
    return show.ticketTypes.reduce((total, type) => {
        return (total +
            ((type.charityFee || 0) + (type.facilityFee || 0)) * (type.sold ?? 0));
    }, 0);
};
exports.calculateTicketFeeActual = calculateTicketFeeActual;
const calculateTicketFeeForecast = (show) => {
    if (!show.ticketTypes || show.ticketTypes.length < 1)
        return 0;
    return show.ticketTypes.reduce((total, type) => {
        return (total +
            ((type.charityFee || 0) + (type.facilityFee || 0)) *
                (type.sold ?? type.soldProjected ?? 0));
    }, 0);
};
exports.calculateTicketFeeForecast = calculateTicketFeeForecast;
const calculateAggBoxOfficeProjected = (showFigures) => {
    return showFigures.reduce((sum, curr) => sum + curr.ticketRevenueProjected, 0);
};
exports.calculateAggBoxOfficeProjected = calculateAggBoxOfficeProjected;
const calculateAggBoxOfficeActual = (showFigures) => {
    return showFigures.reduce((sum, curr) => sum + curr.ticketRevenueActual, 0);
};
exports.calculateAggBoxOfficeActual = calculateAggBoxOfficeActual;
const calculateAggBoxOfficeForecast = (shows) => {
    const aggShowFiguresActual = shows
        .filter((s) => (0, utils_1.isShowInActualStatus)(s))
        .map((s) => (0, exports.calculateShowFigures)(s));
    const aggShowFiguresProjected = shows
        .filter((s) => !(0, utils_1.isShowInActualStatus)(s))
        .map((s) => (0, exports.calculateShowFigures)(s));
    return ((0, exports.calculateAggBoxOfficeActual)(aggShowFiguresActual) +
        (0, exports.calculateAggBoxOfficeProjected)(aggShowFiguresProjected));
};
exports.calculateAggBoxOfficeForecast = calculateAggBoxOfficeForecast;
const calculateAggTicketFeesProjected = (shows) => {
    return shows.reduce((sum, curr) => sum + (0, exports.calculateTicketFeeForecast)(curr), 0);
};
exports.calculateAggTicketFeesProjected = calculateAggTicketFeesProjected;
const calculateAggTicketFeesActual = (shows) => {
    return shows.reduce((sum, curr) => sum + (0, exports.calculateTicketFeeActual)(curr), 0);
};
exports.calculateAggTicketFeesActual = calculateAggTicketFeesActual;
const calculateAggTicketFeesForecast = (shows) => {
    const showsActualStatus = shows.filter((s) => (0, utils_1.isShowInActualStatus)(s));
    const showsProjectedStatus = shows.filter((s) => !(0, utils_1.isShowInActualStatus)(s));
    return ((0, exports.calculateAggTicketFeesActual)(showsActualStatus) +
        (0, exports.calculateAggTicketFeesProjected)(showsProjectedStatus));
};
exports.calculateAggTicketFeesForecast = calculateAggTicketFeesForecast;
const calculateAggGrossAdjustmentsProjected = (shows) => {
    return shows
        .flatMap((show) => show.ticketAdjustments)
        .filter((a) => !!a?.addToGross)
        .reduce((sum, curr) => sum + (curr?.amount ?? 0), 0);
};
exports.calculateAggGrossAdjustmentsProjected = calculateAggGrossAdjustmentsProjected;
const calculateAggGrossAdjustmentsActual = (shows) => {
    return shows
        .flatMap((show) => show.ticketAdjustments)
        .filter((a) => !!a?.addToGross)
        .reduce((sum, curr) => sum + (curr?.amount ?? 0), 0);
};
exports.calculateAggGrossAdjustmentsActual = calculateAggGrossAdjustmentsActual;
const calculateAggGrossAdjustmentsForecast = (shows) => {
    const showsActualStatus = shows.filter((s) => (0, utils_1.isShowInActualStatus)(s));
    const showsProjectedStatus = shows.filter((s) => !(0, utils_1.isShowInActualStatus)(s));
    return ((0, exports.calculateAggGrossAdjustmentsActual)(showsActualStatus) +
        (0, exports.calculateAggGrossAdjustmentsProjected)(showsProjectedStatus));
};
exports.calculateAggGrossAdjustmentsForecast = calculateAggGrossAdjustmentsForecast;
const calculateAggNetAdjustmentsProjected = (shows) => {
    return shows
        .flatMap((show) => show.ticketAdjustments)
        .filter((adj) => !adj.addToGross)
        .reduce((sum, curr) => sum + (curr?.amount ?? 0), 0);
};
exports.calculateAggNetAdjustmentsProjected = calculateAggNetAdjustmentsProjected;
const calculateAggNetAdjustmentsActual = (shows) => {
    return shows
        .flatMap((show) => show.ticketAdjustments)
        .filter((a) => !a?.addToGross)
        .reduce((sum, curr) => sum + (curr?.amount ?? 0), 0);
};
exports.calculateAggNetAdjustmentsActual = calculateAggNetAdjustmentsActual;
const calculateAggNetAdjustmentsForecast = (shows) => {
    const showsActualStatus = shows.filter((s) => (0, utils_1.isShowInActualStatus)(s));
    const showsProjectedStatus = shows.filter((s) => !(0, utils_1.isShowInActualStatus)(s));
    return ((0, exports.calculateAggNetAdjustmentsActual)(showsActualStatus) +
        (0, exports.calculateAggNetAdjustmentsProjected)(showsProjectedStatus));
};
exports.calculateAggNetAdjustmentsForecast = calculateAggNetAdjustmentsForecast;
const calculateAggGrossDeductionsProjected = (shows) => {
    return shows
        .flatMap((show) => show.deductions)
        .filter((a) => !!a?.addToGross)
        .reduce((sum, curr) => sum + (curr?.amount ?? 0), 0);
};
exports.calculateAggGrossDeductionsProjected = calculateAggGrossDeductionsProjected;
const calculateAggGrossDeductionsActual = (shows) => {
    return shows
        .flatMap((show) => show.deductions)
        .filter((a) => !!a?.addToGross)
        .reduce((sum, curr) => sum + (curr?.amount ?? 0), 0);
};
exports.calculateAggGrossDeductionsActual = calculateAggGrossDeductionsActual;
const calculateAggGrossDeductionsForecast = (shows) => {
    const showsActualStatus = shows.filter((s) => (0, utils_1.isShowInActualStatus)(s));
    const showsProjectedStatus = shows.filter((s) => !(0, utils_1.isShowInActualStatus)(s));
    return ((0, exports.calculateAggGrossDeductionsActual)(showsActualStatus) +
        (0, exports.calculateAggGrossDeductionsProjected)(showsProjectedStatus));
};
exports.calculateAggGrossDeductionsForecast = calculateAggGrossDeductionsForecast;
const calculateAggNetDeductionsProjected = (shows) => {
    return shows
        .flatMap((show) => show.deductions)
        .filter((a) => !a?.addToGross)
        .reduce((sum, curr) => sum + (curr?.amount ?? 0), 0);
};
exports.calculateAggNetDeductionsProjected = calculateAggNetDeductionsProjected;
const calculateAggNetDeductionsActual = (shows) => {
    return shows
        .flatMap((show) => show.deductions)
        .filter((a) => !a?.addToGross)
        .reduce((sum, curr) => sum + (curr?.amount ?? 0), 0);
};
exports.calculateAggNetDeductionsActual = calculateAggNetDeductionsActual;
const calculateAggNetDeductionsForecast = (shows) => {
    const showsActualStatus = shows.filter((s) => (0, utils_1.isShowInActualStatus)(s));
    const showsProjectedStatus = shows.filter((s) => !(0, utils_1.isShowInActualStatus)(s));
    return ((0, exports.calculateAggNetDeductionsActual)(showsActualStatus) +
        (0, exports.calculateAggNetDeductionsProjected)(showsProjectedStatus));
};
exports.calculateAggNetDeductionsForecast = calculateAggNetDeductionsForecast;
const calculateAggVenueExpensesProjected = (shows) => {
    return shows
        .flatMap((show) => show.expenses)
        .reduce((sum, curr) => sum + curr.cost, 0);
};
exports.calculateAggVenueExpensesProjected = calculateAggVenueExpensesProjected;
const calculateAggVenueExpensesActual = (shows) => {
    return shows
        .flatMap((show) => show.expenses)
        .reduce((sum, curr) => sum + curr.actualCost, 0);
};
exports.calculateAggVenueExpensesActual = calculateAggVenueExpensesActual;
const calculateAggVenueExpensesForecast = (shows) => {
    const showsActualStatus = shows.filter((s) => (0, utils_1.isShowInActualStatus)(s));
    const showsProjectedStatus = shows.filter((s) => !(0, utils_1.isShowInActualStatus)(s));
    return ((0, exports.calculateAggVenueExpensesActual)(showsActualStatus) +
        (0, exports.calculateAggVenueExpensesProjected)(showsProjectedStatus));
};
exports.calculateAggVenueExpensesForecast = calculateAggVenueExpensesForecast;
const calculateAggRevenueToSplitProjected = (showFigures) => {
    return showFigures.reduce((sum, curr) => sum + curr.revenueToSplitProjected, 0);
};
exports.calculateAggRevenueToSplitProjected = calculateAggRevenueToSplitProjected;
const calculateAggRevenueToSplitActual = (showFigures) => {
    return showFigures.reduce((sum, curr) => sum + curr.revenueToSplitActual, 0);
};
exports.calculateAggRevenueToSplitActual = calculateAggRevenueToSplitActual;
const calculateAggRevenueToSplitForecast = (shows) => {
    const aggShowFiguresActual = shows
        .filter((s) => (0, utils_1.isShowInActualStatus)(s))
        .map((s) => (0, exports.calculateShowFigures)(s));
    const aggShowFiguresProjected = shows
        .filter((s) => !(0, utils_1.isShowInActualStatus)(s))
        .map((s) => (0, exports.calculateShowFigures)(s));
    return ((0, exports.calculateAggRevenueToSplitActual)(aggShowFiguresActual) +
        (0, exports.calculateAggRevenueToSplitProjected)(aggShowFiguresProjected));
};
exports.calculateAggRevenueToSplitForecast = calculateAggRevenueToSplitForecast;
const calculateAggArtistShareOfRevenueProjected = (showFigures) => {
    return showFigures.reduce((sum, curr) => sum + curr.artistShareOfRevenueProjected, 0);
};
exports.calculateAggArtistShareOfRevenueProjected = calculateAggArtistShareOfRevenueProjected;
const calculateAggArtistShareOfRevenueActual = (showFigures) => {
    return showFigures.reduce((sum, curr) => sum + curr.artistShareOfRevenueActual, 0);
};
exports.calculateAggArtistShareOfRevenueActual = calculateAggArtistShareOfRevenueActual;
const calculateAggArtistShareOfRevenueForecast = (shows) => {
    const aggShowFiguresActual = shows
        .filter((s) => (0, utils_1.isShowInActualStatus)(s))
        .map((s) => (0, exports.calculateShowFigures)(s));
    const aggShowFiguresProjected = shows
        .filter((s) => !(0, utils_1.isShowInActualStatus)(s))
        .map((s) => (0, exports.calculateShowFigures)(s));
    return ((0, exports.calculateAggArtistShareOfRevenueActual)(aggShowFiguresActual) +
        (0, exports.calculateAggArtistShareOfRevenueProjected)(aggShowFiguresProjected));
};
exports.calculateAggArtistShareOfRevenueForecast = calculateAggArtistShareOfRevenueForecast;
const calculateAggBonusesProjected = (showFigures) => {
    return showFigures.reduce((sum, curr) => sum + curr.bonusesProjected, 0);
};
exports.calculateAggBonusesProjected = calculateAggBonusesProjected;
const calculateAggBonusesActual = (showFigures) => {
    return showFigures.reduce((sum, curr) => sum + curr.bonusesActual, 0);
};
exports.calculateAggBonusesActual = calculateAggBonusesActual;
const calculateAggBonusesForecast = (shows) => {
    const aggShowFiguresActual = shows
        .filter((s) => (0, utils_1.isShowInActualStatus)(s))
        .map((s) => (0, exports.calculateShowFigures)(s));
    const aggShowFiguresProjected = shows
        .filter((s) => !(0, utils_1.isShowInActualStatus)(s))
        .map((s) => (0, exports.calculateShowFigures)(s));
    return ((0, exports.calculateAggBonusesActual)(aggShowFiguresActual) +
        (0, exports.calculateAggBonusesProjected)(aggShowFiguresProjected));
};
exports.calculateAggBonusesForecast = calculateAggBonusesForecast;
const calculateAggWalkoutProjected = (showFigures) => {
    return showFigures.reduce((sum, curr) => sum + curr.walkoutProjected, 0);
};
exports.calculateAggWalkoutProjected = calculateAggWalkoutProjected;
const calculateAggWalkoutActual = (showFigures) => {
    return showFigures.reduce((sum, curr) => sum + curr.walkout, 0);
};
exports.calculateAggWalkoutActual = calculateAggWalkoutActual;
const calculateAggWalkoutForecast = (shows) => {
    const aggShowFiguresActual = shows
        .filter((s) => (0, utils_1.isShowInActualStatus)(s))
        .map((s) => (0, exports.calculateShowFigures)(s));
    const aggShowFiguresProjected = shows
        .filter((s) => !(0, utils_1.isShowInActualStatus)(s))
        .map((s) => (0, exports.calculateShowFigures)(s));
    return ((0, exports.calculateAggWalkoutActual)(aggShowFiguresActual) +
        (0, exports.calculateAggWalkoutProjected)(aggShowFiguresProjected));
};
exports.calculateAggWalkoutForecast = calculateAggWalkoutForecast;
const calculateAggGuaranteeUsedProjected = (shows) => {
    const aggShowFiguresProjected = shows
        .filter((s) => !(0, utils_1.isShowInActualStatus)(s))
        .map((s) => (0, exports.calculateShowFigures)(s));
    return aggShowFiguresProjected.filter((figs) => figs.show.dealType !== show_1.ShowDealType.VERSUS ||
        figs.walkoutProjected <= figs.walkoutMinimum);
};
exports.calculateAggGuaranteeUsedProjected = calculateAggGuaranteeUsedProjected;
const calculateAggGuaranteeUsedActual = (shows) => {
    const aggShowFiguresActual = shows
        .filter((s) => (0, utils_1.isShowInActualStatus)(s))
        .map((s) => (0, exports.calculateShowFigures)(s));
    return aggShowFiguresActual.filter((figs) => figs.show.dealType !== show_1.ShowDealType.VERSUS ||
        figs.walkout <= figs.walkoutMinimum);
};
exports.calculateAggGuaranteeUsedActual = calculateAggGuaranteeUsedActual;
const calculateAggBuyouts = (shows) => {
    return shows
        .flatMap((show) => show.productionBuyouts)
        .reduce((sum, curr) => sum + (curr?.amount ?? 0), 0);
};
exports.calculateAggBuyouts = calculateAggBuyouts;
exports.__test = {
    calculateTicketPrice,
    calculateTicketPotential,
    calculateTicketProjected,
    calculateTicketActual,
    calculateDeductionsTotal: exports.calculateNetDeductions,
    calculateBonusesAndProfitShare,
    calculateShowNet,
};
//# sourceMappingURL=live.js.map
//# debugId=d3c83d10-004b-5015-93ee-43bff763fcda
